<template>
	<div>
		<GBMemberListRowInsertPosition v-if="isRowMove &&!isSelected && PositionFirst"
			v-bind:item=item
			v-bind:PositionFirst="PositionFirst"
			v-on:insert-member-row="InsertMemberRow"
			v-on:insert-member-row-top="InsertMemberRowTop"
		/>
		<GBMemberListRow
			v-bind:item=item
			v-bind:isEditable="isEditable"
			v-bind:isSelected="isSelected"
			v-bind:isSpliced="isSpliced"
			v-bind:watchSlide="watchSlide"
			v-bind:PositionFirst="PositionFirst"
			v-bind:isRowMove="isRowMove"
			v-on:schedule-list-row-slide="onScheduleListRowSlide"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:member-row-move-start="memberRowMoveStart"
			v-on:member-row-move-end="memberRowMoveEnd"
			ref="rows"
		/>
		<GBMemberListRowInsertPosition v-if="isRowMove &&!isSelected && !isSelectedBeforeItem"
			v-bind:item=item
			v-bind:PositionFirst="false"
			v-on:insert-member-row="InsertMemberRow"
		/>
	</div>
</template>
<script>
import GBMemberListRow from './GBMemberListRow';
import GBMemberListRowInsertPosition from './GBMemberListRowInsertPosition';
export default {
	name: 'GBMemberListRowOuter',
	components: {
		GBMemberListRow,
		GBMemberListRowInsertPosition
	},
	props: [
		"item",
		"isEditable",
		"watchSlide",
		"isSelected",
		"isSpliced",
		"PositionFirst",
		"isRowMove",
		"isSelectedBeforeItem",
	],
	methods: {
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		memberRowMoveStart: function(e) {
			this.$emit('member-row-move-start',e);
		},
		
		memberRowMoveEnd: function(e) {
			this.$emit('member-row-move-end',e);
		},
		onScheduleListRowSlide: function(e) {
			this.$emit('schedule-list-row-slide',e);
		},
		InsertMemberRow: function(e){
			this.$emit('insert-member-row',e);
		},
		InsertMemberRowTop: function(e){
			this.$emit('insert-member-row-top',e);
		},
	}
};
</script>
<style>
</style>
